import { ApplicationConfig, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideCharts } from 'ng2-charts';
import { ChoroplethController, ColorScale, GeoFeature, ProjectionScale } from 'chartjs-chart-geo';

import { routes } from './routing/app.routes';
import { provideHttpClient, withXhr } from '@angular/common/http';
import { withInterceptors } from '@angular/common/http';
import { authInterceptor } from './interceptors/auth.interceptor';
import { provideAnalytics } from './state/analytics/analytics.service';
import {
  BarController,
  BarElement,
  CategoryScale,
  Filler,
  LinearScale,
  LineController,
  LineElement,
  plugins,
  PointElement,
  TimeScale,
  Tooltip,
} from 'chart.js';
import 'chartjs-adapter-dayjs-4/dist/chartjs-adapter-dayjs-4.esm';
import { MatrixController, MatrixElement } from 'chartjs-chart-matrix';
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';

ModuleRegistry.registerModules([AllCommunityModule]);
export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withXhr(), withInterceptors([authInterceptor])),
    provideZonelessChangeDetection(),
    provideCharts({
      registerables: [
        Tooltip,
        CategoryScale,
        LinearScale,
        PointElement,
        LineElement,
        LineController,
        Filler,
        ChoroplethController,
        ProjectionScale,
        ColorScale,
        GeoFeature,
        BarController,
        BarElement,
        plugins.Title,
        plugins.Legend,
        TimeScale,
        MatrixController,
        MatrixElement,
      ],
    }),
    provideRouter(routes),
    provideAnalytics,
  ],
};
